const formatDuration = (t) => {
  if (t == null) return t
  if (t === 0) return '0s'

  const h = Math.floor(t / 3600)
  const m = Math.floor(t % 3600 / 60)
  const s = Math.floor(t % 3600 % 60)
  const hDisplay = h > 0 ? h + 'h ' : ''
  const mDisplay = m > 0 ? m + 'm ' : ''
  const sDisplay = s > 0 ? s + 's' : ''
  return hDisplay + mDisplay + sDisplay
}

export default formatDuration
